import { Header4, TColors } from '@cian/ui-kit/typography';

import { clsx } from 'clsx';
import { FC } from 'react';

import { amenitiesGroups } from '../../constants';
import { getAmenityItem } from '../../helpers';
import { Amenity } from '../Amenity';

import { IAmenitiesGroup, IRenderAmenities } from './types';

import * as styles from './AmenitiesGroup.css';

export function renderAmenities({ amenities, coworkingAmenities }: IRenderAmenities) {
  return amenities.map((amenity, amenityIndex) => {
    const isExist = coworkingAmenities.includes(amenity);
    let color: TColors = 'black_100';
    let cssClass = styles['amenity-yes'];

    if (!isExist) {
      cssClass = styles['amenity-no'];
      color = 'black_40';
    }

    const currentAmenity = getAmenityItem(amenity);
    if (currentAmenity) {
      const { title, icon } = currentAmenity;

      return (
        <Amenity
          className={cssClass}
          color={color}
          icon={icon}
          key={`amenity-${amenityIndex}-${amenity}`}
          keyName={amenity}
          title={title}
        />
      );
    }

    return undefined;
  });
}

export const AmenitiesGroup: FC<IAmenitiesGroup> = props => {
  const { coworkingAmenities, className } = props;

  return (
    <>
      {amenitiesGroups.map(({ title, key, amenities }, groupIndex) => {
        const amenitiesViews = renderAmenities({ amenities, coworkingAmenities });

        return (
          <div className={clsx(styles['root'], className)} key={`group-${groupIndex}-${key}`}>
            <Header4>{title}</Header4>
            <div className={styles['amenity-list']}>{amenitiesViews}</div>
          </div>
        );
      })}
    </>
  );
};

AmenitiesGroup.displayName = 'AmenitiesGroup';
